import { css } from '@emotion/css'

export const Container = css`
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const InputStyles = css`
  width: 100%;
`

export const AdditionalButtonsContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
`

export const AdditionalButton = css`
  text-decoration: none;
  font-size: 14px;
  font-weight: 300;
`

export const SubmitBtn = css`
  width: 100%;
  height: 46px;
`

export const Title = css`
  font-size: 24px;
  font-weight: 700;
  margin: 0px;
  text-align: center;
`

export const GreetingText = css`
  text-align: center;
  font-size: 14px;
`

export const Texts = css`
  width: 100%;
  padding: 20px 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`
